<template>

	<v-dialog
	  v-model="dialogDirectorio.estatus" 
	  max-width="1000px"
	  transition="dialog-transition"
	>
		<v-card class="shadowCard">
		  <v-card-title primary-title>
		    <span class="text-subtitle-1">Directorio General</span>
		    <v-spacer></v-spacer>

        <v-btn
          color="primary"
          dark
          class="text-capitalize"
          @click="initialize()"
          small
          tile
        >
          <v-icon left small>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
		  </v-card-title>
      
		  <v-card-text>
		  	<v-row justify="end">
		  		<v-col cols="12" md="4">
		  			<v-text-field
		  			  name="name"
		  			  label="Buscar"
		  			  id="id"
		  			  filled
		  			  dense
		  			  hide-details
		  			  append-icon="mdi-magnify"
		  			  v-model="search"
		  			></v-text-field>
		  		</v-col>
		  		<v-col cols="12" md="4">
		  			<v-text-field
		  			  label="Buscar teachers"
		  			  filled
		  			  dense
		  			  hide-details
		  			  append-icon="mdi-magnify"
		  			  v-model="searchTeachers"
		  			></v-text-field>
		  		</v-col>
		  	</v-row>
		    <v-row>
		    	<v-col cols="12">
		    		<div>Directorio INBI</div>
					  <v-data-table
					    :headers="headers"
					    :items="directorioInbi"
					    class="elevation-0"
					    :search="search"
					    :mobile-breakpoint="100"
	            dense
					  >
					    <template v-slot:no-data>
					      <v-btn
					        color="primary"
					        @click="initialize"
					        small
					      >
					        Actualizar
					      </v-btn>
					    </template>
					  </v-data-table>
			  	</v-col>
			  </v-row>


			  <v-row>
		    	<v-col cols="12">
		    		<div>Directorio FAST</div>
					  <v-data-table
					    :headers="headers"
					    :items="directorioFast"
					    class="elevation-0"
					    :search="search"
					    :mobile-breakpoint="100"
	            dense
					  >
					    <template v-slot:no-data>
					      <v-btn
					        color="primary"
					        @click="initialize"
					        small
					      >
					        Actualizar
					      </v-btn>
					    </template>
					  </v-data-table>
			  	</v-col>
			  </v-row>

			  <v-row>
		    	<v-col cols="12">
		    		<div class="mb-2">Teachers</div>
					  <v-data-table
					    :headers="headersTeachers"
					    :items="teachersFiltrados"
					    :loading="cargar"
					    loading-text="Cargando teachers..."
					    class="elevation-0"
					    :search="searchTeachers"
					    :mobile-breakpoint="100"
	            dense
					  >
					    <template v-slot:no-data>
					      <v-btn
					        color="primary"
					        @click="initialize"
					        small
					      >
					        Actualizar
					      </v-btn>
					    </template>
					  </v-data-table>
			  	</v-col>
			  </v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    props:[
			'dialogDirectorio',
	  ],

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      headers: [
        { text: 'Plantel'       , value: 'plantel' },
        { text: 'T. Princial'   , value: 'tel_principal'   },
        // { text: 'T. Secundario' , value: 'tel_secundario'  },
        { text: 'Wpp Ventas'    , value: 'wpp_ventas'      },
        { text: 'Wpp Sucursal'  , value: 'wpp_sucursal'    },
      ],
      directorio: [],
      // tabla
			search:'',
			searchTeachers: '',

			directorioInbi:[],
			directorioFast:[],

			ciclo: null,
			teachers: [],
			gruposRoles: [],
			headersTeachers: [
				{ text: 'Nombre', value: 'nombre_completo' },
				{ text: 'Plantel', value: 'plantel' },
				{ text: 'Teléfono', value: 'telefono1' },
			],

    }),

    computed:{
      ...mapGetters('login',['getdatosUsuarioERPERP','getLogeado', 'getEscuela','getEstatusLlamada','getTareas','getNuevosProspectos']),
      ...mapGetters('tema', ['getTema']),
      ...mapGetters('Carrito',['getCarrito']),
      teachersFiltrados() {
        let lista = this.teachers || []
        const usuario = this.getdatosUsuarioERPERP
        if (!usuario) return lista
        if ([18, 19].includes(usuario.idpuesto) && ![382, 161, 626, 7, 568].includes(usuario.iderp)) {
          const idsRolados = this.getIdsTeachersRoladosEnSucursal()
          lista = lista.filter(t => idsRolados.includes(t.id_usuario))
        }
        return lista
      },
    },

    created () {
    	console.log( 'escuela',this.getEscuela)
      this.initialize()
    },

    methods: {
      getIdsTeachersRoladosEnSucursal() {
        const usuario = this.getdatosUsuarioERPERP
        if (!usuario || !usuario.id_plantel) return []
        const grupos = (this.gruposRoles || []).filter(el => el && el.deleted == 0 && el.id_plantel == usuario.id_plantel)
        const ids = new Set()
        const bloques = ['lu1','ma1','mi1','ju1','vi1','lu2','ma2','mi2','ju2','vi2','lu3','ma3','mi3','ju3','vi3','lu4','ma4','mi4','ju4','vi4','lu5','ma5','mi5','ju5','vi5']
        grupos.forEach(gr => {
          bloques.forEach(b => {
            if (gr[b]) ids.add(gr[b])
          })
        })
        return [...ids]
      },
      getCicloActual() {
        return this.$http.get('roles.ciclos.all').then(response => {
          const ciclos = (response.data || []).filter(el => el && el.ciclo && el.ciclo.search('FE') == -1 && el.ciclo.search('CICLO 02_26') != -1)
          this.ciclo = ciclos.length ? ciclos[0] : null
          return this.ciclo
        })
      },
      loadTeachers() {
        if (!this.ciclo) return Promise.resolve()
        return this.$http.post('rol.clases', this.ciclo).then(response => {
          this.gruposRoles = response.data.respuesta || []
          this.teachers = response.data.teachers || []
        }).catch(() => {
          this.teachers = []
          this.gruposRoles = []
        })
      },
      initialize () {
      	this.cargar = true
        this.directorio = []
        this.teachers = []
        this.gruposRoles = []
        return this.$http.get('planteles.list.erp').then(response=>{
        	console.log( response.data )

        	if( [18,19].includes( this.getdatosUsuarioERPERP.idpuesto ) ){
        		this.directorio = response.data.filter( el => el.escuela == this.getEscuela && !el.plantel.match('Entrenam') && !el.plantel.match('CEAA') && !el.plantel.match('XOLA'))
        	}else{
        		this.directorio = response.data.filter( el => !el.plantel.match('Entrenam') && !el.plantel.match('CEAA') && !el.plantel.match('XOLA') )
        	}

        	this.directorio = this.directorio.filter( el => el.activo_sn == 1 )
        	this.directorio = this.directorio.filter( el => el.plantel != 'CORPORATIVO' && el.id_plantel != 19 && el.id_plantel != 20 )

        	this.directorioInbi = this.directorio.filter( el => !el.plantel.match('FAST'))
        	this.directorioFast = this.directorio.filter( el => el.plantel.match('FAST'))

        	return this.getCicloActual()
        }).then(() => this.loadTeachers()).catch( error =>{
          this.validarError( error.response && error.response.data && error.response.data.message )
        }).finally( () => { this.cargar = false })
      },
    }
  }
</script>


